import UserClass from "./UserClass"

const About =()=>{
    return (
        <div>
            <h1>Hello from the About component</h1>
            <UserClass name={"Apurv Mishra"} location={"Kanpur, Uttar Pradesh"} contact={"@__mishra_g_790"}/>
        </div>
    )
}

export default About